import { useRouter } from "next/router";
import ReactMarkdown from "react-markdown";

import styles from "@/styles/circle-hero.module.scss";

const CircleHero = ({ data }) => {
  const router = useRouter();
  const isAbout = router.asPath === "/about";
  return (
    <section
      className={`flex justify-center text-center px-5 items-center md:h-[480px] ${
        styles.bg
      } ${isAbout ? "h-[382px]" : "h-[494px]"} ${
        data.oBackground === "black" ? "bg-onmoBlack text-white" : ""
      }`}
    >
      <div className="flex flex-col gap-5">
        <h1 className={styles.title}>{data.title}</h1>
        {data.description === null ? null : (
          <ReactMarkdown className={styles.description}>
            {data.description}
          </ReactMarkdown>
        )}
      </div>
    </section>
  );
};

export default CircleHero;
